import api from '@/shared/utils/apiConfig';
import type { DrugFormData } from '@/modules/prescription/types/drug';

interface DrugParams {
  [key: string]: any;
}

interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
  [key: string]: any;
}

export const drugAPI = {
  getDrugs: async (params: DrugParams = {}): Promise<ApiResponse> => {
    const response = await api.get('/drugs', { params });
    return response.data;
  },

  getDrug: async (id: string): Promise<ApiResponse> => {
    const response = await api.get(`/drugs/${id}`);
    return response.data;
  },

  createDrug: async (drugData: DrugFormData): Promise<ApiResponse> => {
    const response = await api.post('/drugs', drugData);
    return response.data;
  },

  updateDrug: async (id: string, drugData: Partial<DrugFormData>): Promise<ApiResponse> => {
    const response = await api.put(`/drugs/${id}`, drugData);
    return response.data;
  },

  deleteDrug: async (id: string): Promise<ApiResponse> => {
    const response = await api.delete(`/drugs/${id}`);
    return response.data;
  },

  bulkImportDrugs: async (drugs: DrugFormData[]): Promise<ApiResponse> => {
    const response = await api.post('/drugs/bulk-import', { drugs });
    return response.data;
  }
};

